<template>
  <overlay v-model="value" @click="hide">
    <div :class="elementClass">
      <scrollbar>
        <slot></slot>
      </scrollbar>
    </div>
  </overlay>
</template>

<script>
import Scrollbar from "./Scrollbar";
import Overlay from "./Overlay";
import { navigationClass } from "../prefix";
import ClickOutside from "vue-click-outside";
export default {
  components: {
    Scrollbar,
    Overlay,
  },
  directives: {
    ClickOutside,
  },
  props: {
    value: {
      default: false,
      type: Boolean,
    },
  },
  methods: {
    hide() {
      if (this.value) {
        this.$emit("input", false);
      }
    },
  },
  computed: {
    elementClass() {
      return [navigationClass, this.value ? " active" : ""];
    },
  },
};
</script>

<style lang="scss">
@import "../scss/import.scss";
$element: $prefix + "-navigation";

#{$element} {
  width: 320px;
  height: 100vh;
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  background: $color-white;
  @include elevation(1);
  @include transform(translateX(-100%));
  @include transition(all 0.25s $animation-deceleration-curve-timing-function);
  visibility: visible;
  &.active {
    @include transform(translateX(0));
  }
}
</style>
